__turbopack_context__.v({
  "isDisabled": "tag-module-scss-module___OCKCa__isDisabled",
  "tag": "tag-module-scss-module___OCKCa__tag",
  "tagDeleteBtn": "tag-module-scss-module___OCKCa__tagDeleteBtn",
  "tagTitle": "tag-module-scss-module___OCKCa__tagTitle",
});
